module.exports = (__webpack_require__(2))("./core/router.js");


//////////////////
// WEBPACK FOOTER
// delegated ./core/router.js from dll-reference base
// module id = 100
// module chunks = 22